export default "__VITE_ASSET__DVLhLi7P__"